import type { FaqGroup } from '@/types'

export const supportFaqGroups: FaqGroup[] = [
    {
        id: 'shipping',
        title: 'Shipping & delivery',
        titleLines: ['Shipping &', 'delivery'],
        items: [
            {
                question: 'How long will it take to arrive?',
                answer: 'Orders leave us within 1-2 working days. Europe arrives in 2-4 days, the US and Canada in 3-6, and the rest of the world within 7-14 depending on how quickly customs moves.'
            },
            {
                question: 'Do you ship everywhere?',
                answer: 'We ship to most countries. A handful are excluded by our carrier rather than by us, and checkout will tell you before you pay rather than after.'
            },
            {
                question: 'Is shipping really free?',
                answer: 'Yes, on every order, to every country, with no minimum. It is built into the price rather than added at the end.'
            },
            {
                question: 'Can I track it?',
                answer: 'A tracking number and carrier link are emailed the moment your parcel is scanned. If it goes quiet for more than 48 hours, write to us and we will chase it.'
            },
            {
                question: 'Do you offer express delivery?',
                answer: 'Express is available at checkout in most countries and typically halves the transit time. It is the one thing we charge extra for.'
            }
        ]
    },
    {
        id: 'returns',
        title: 'Returns & refunds',
        titleLines: ['Returns &', 'refunds'],
        items: [
            {
                question: 'What is the return policy?',
                answer: 'Thirty days from delivery, for a full refund of what you paid. Skincare takes time to judge, so the window starts when it arrives rather than when you ordered.'
            },
            {
                question: 'How do I start a return?',
                answer: 'Email hello@nuvea.com with your order number. There is no form and no portal. We reply with a prepaid label the same working day.'
            },
            {
                question: 'Do I have to send the jar back?',
                answer: 'Not for a refund. We would rather you kept using it or passed it on than posted a half-used jar across a continent. If you want to return the glass for recycling, the label covers it.'
            },
            {
                question: 'Who pays return postage?',
                answer: 'We do, worldwide. It is a prepaid label, so nothing comes out of your pocket and nothing is deducted from the refund.'
            },
            {
                question: 'How long do refunds take?',
                answer: 'We process within one working day of your email. Your bank then takes its own 3-5 days to show it, which is the part none of us control.'
            },
            {
                question: 'Can I swap sizes instead?',
                answer: 'Yes. Say which size you would rather have in your email and we will send it out and refund or charge the difference. No need to return the first one before the second ships.'
            }
        ]
    }
]

export const legalCards = [
    {
        href: '/payment-methods',
        title: 'Payment Methods',
        body: 'Every card and wallet we take, how your details are handled, and the moment you are actually charged.'
    },
    {
        href: '/terms',
        title: 'Terms & Conditions',
        body: 'The agreement between you and Nuvéa when you order, return, or simply read this site.'
    },
    {
        href: '/privacy-policy',
        title: 'Privacy Policy',
        body: 'What we collect, why, how long we keep it, and how to make us delete it.'
    }
]
